
import { AppBar , Toolbar , styled} from '@mui/material' ; 

const Container = styled(AppBar)`
 background : #060606 ; 
 height : 12vh ; 

`
const Tool = styled(Toolbar)`
 display : flex ; 
 justify-content : center ; 
`
const Header = () =>{
    
    return (
        <Container position='static'>
        <Tool>
            <img src={require('./806c54e8-979c-4afe-923e-a0d442ab80e9.jpg')} alt="logo" style={{ maxWidth : 110 }}></img>
        </Tool>
       </Container>

    )
}

export default Header ; 